"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=IQueryContext.js.map